export const CircleLoaderIcon = ({ className, size = 16 }: { className?: string; size?: number }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.5" cy="12" r="6" transform="rotate(90 12.5 12)" stroke="#404040" strokeWidth="2" />
      <path
        d="M12.5 18C11.7121 18 10.9319 17.8448 10.2039 17.5433C9.47595 17.2417 8.81451 16.7998 8.25736 16.2426C7.70021 15.6855 7.25825 15.0241 6.95672 14.2961C6.65519 13.5681 6.5 12.7879 6.5 12"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};
